import React from 'react';
import { motion } from 'framer-motion';
import NumberCounter from 'number-counter';
import { Header } from '../Header/Header';
import hero_image from '../../assets/hero_image.png';
import hero_image_back from '../../assets/hero_image_back.png';
import heart from '../../assets/heart.png';
import calories from '../../assets/calories.png';

import './Hero.css';

export function Hero() {
  const transition = { type: 'spring', duration: 3 };
  const isMobile = window.innerWidth < 768;
  return (
    <div className="hero" id="home">
      <div className="blur hero-blur"></div>
      <div className="left-h">
        <Header />
        <div className="the-best-ad">
          <motion.div
            initial={{ left: isMobile ? '165px' : '238px' }}
            whileInView={{ left: '8px' }}
            transition={{ ...transition, type: 'linear' }}
          ></motion.div>
          <span>the best fitness club in the town</span>
        </div>
        <div className="hero-text">
          <div>
            <span className="stroke-text">Shape </span>
            <span>Your</span>
          </div>
          <div>
            <span>Ideal body</span>
          </div>
          <div className="brief-description">
          In here we will help you to shape and build your ideal body and live up your life to fullest
          </div>
        </div>
        <div className="figures">
          <div>
            <span><NumberCounter start={100} end={140} delay="4" preFix="+"/></span>
            <span>expert coaches</span>
          </div>
          <div>
            <span><NumberCounter start={800} end={978} delay="4" preFix="+"/></span>
            <span>MEMBERS JOINED</span>
          </div>
          <div>
            <span><NumberCounter start={0} end={50} delay="4" preFix="+"/></span>
            <span>FITNESS PROGRAMS</span>
          </div>
        </div>
        <div className="hero-buttons">
          <button className="btn">Get Started</button>
          <button className="btn">Learn More</button>
        </div>
      </div>
      <div className="right-h">
        <button className="btn">Join Now</button>

        <motion.div
          className="heart-rate"
          initial={{ right: '-1rem' }}
          whileInView={{ right: '4rem' }}
          transition={transition}
        >
          <img src={heart} alt="" />
          <span>Heart Rate</span>
          <span>116 bpm</span>
        </motion.div>

        <img src={hero_image} alt="" className="hero-image" />
        <motion.img
          src={hero_image_back}
          alt=""
          className="hero-image-back"
          initial={{ right: '11rem' }}
          whileInView={{ right: '20rem' }}
          transition={transition}
        />

        <motion.div
          className="calories"
          initial={{ right: '37rem' }}
          whileInView={{ right: '28rem' }}
          transition={transition}
        >
          <img src={calories} alt="" />
          <div>
            <span>Calories Burned</span>
            <span>220 kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  )
}
